module.exports = __webpack_public_path__ + "img/plus.306ca197.svg";